import React, { useState, useContext } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { AppContext } from "../../../../../context/appContext";
import HomeSectionCategory from "./HomeSectionCategory";
import HomeSectionContent from "./HomeSectionContent";

export default function HomeSectionManager() {
  const { t, isRTL } = useContext(AppContext);
  const [viewMode, setViewMode] = useState("category"); // 'category' or 'content'
  const [currentCategoryId, setCurrentCategoryId] = useState(null); // null = root level
  const [breadcrumb, setBreadcrumb] = useState([{ id: null, title: t('section.root') || 'Root' }]);

  const handleNavigateToCategory = (categoryId, categoryTitle) => {
    setCurrentCategoryId(categoryId);
    setBreadcrumb([...breadcrumb, { id: categoryId, title: categoryTitle }]);
  };

  const handleNavigateBack = () => {
    if (breadcrumb.length > 1) {
      const newBreadcrumb = [...breadcrumb];
      newBreadcrumb.pop();
      setBreadcrumb(newBreadcrumb);
      setCurrentCategoryId(newBreadcrumb[newBreadcrumb.length - 1].id);
    }
  };

  const handleBreadcrumbClick = (index) => {
    const newBreadcrumb = breadcrumb.slice(0, index + 1);
    setBreadcrumb(newBreadcrumb);
    setCurrentCategoryId(newBreadcrumb[newBreadcrumb.length - 1].id);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">{t('section.title') || 'Home Section Management'}</h2>

      {/* Navigation Bar */}
      <div className="bg-white rounded-xl shadow-sm p-4 mb-4">
        <div className="flex justify-between items-center">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2">
            {breadcrumb.length > 1 && (
              <button
                onClick={handleNavigateBack}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-800 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <FaArrowLeft size={16} />
                <span className="font-medium">{t('common.back')}</span>
              </button>
            )}
            <div className="flex items-center gap-2 text-sm">
              {breadcrumb.map((crumb, index) => (
                <React.Fragment key={index}>
                  {index > 0 && (
                    <span className="text-gray-400">{isRTL ? '←' : '→'}</span>
                  )}
                  <button
                    onClick={() => handleBreadcrumbClick(index)}
                    className={`px-3 py-1 rounded-lg transition-colors ${
                      index === breadcrumb.length - 1
                        ? 'bg-blue-100 text-blue-700 font-semibold'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {crumb.title}
                  </button>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* View Mode Switcher */}
          <div className="flex items-center bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => setViewMode("category")}
              className={`px-4 py-2 rounded-md font-medium transition-all ${
                viewMode === "category"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              {t('section.categoryView') || 'Category View'}
            </button>
            <button
              onClick={() => setViewMode("content")}
              className={`px-4 py-2 rounded-md font-medium transition-all ${
                viewMode === "content"
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              {t('section.contentView') || 'Content View'}
            </button>
          </div>
        </div>
      </div>

      {/* Render the appropriate view */}
      {viewMode === "category" ? (
        <HomeSectionCategory
          currentCategoryId={currentCategoryId}
          onNavigateToCategory={handleNavigateToCategory}
          breadcrumb={breadcrumb}
        />
      ) : (
        <HomeSectionContent
          currentCategoryId={currentCategoryId}
        />
      )}
    </div>
  );
}
